module.exports = __webpack_public_path__ + "media/images/products-img-05-68d2679853d58f151eae0a04bf04fd22.png";